import { createAction } from "@reduxjs/toolkit";

export const AddCandidats = createAction('candidats/add');
export const LoadAllCandidats = createAction('candidats/load');
export const ClearListCandidats = createAction('candidats/clear');
export const ClearListCandidatsSelectedForSelection = createAction('candidats/clearSelection');
export const SetSelectedCandidatBeAddToSelection = createAction('candidats/selection');

